<template>
  <div>
    <v-row class="topTool ma-0">
      <v-col cols="12" lg="9" md="9" class="int-info-col">
        <v-toolbar-title class="int-info">{{$t('lbl.integrationSET.itemDetails')}}</v-toolbar-title>
      </v-col>
      <v-col cols="12" lg="3" md="3" class="int-info-col">
        <v-text-field
          v-model="search"
          class="color-search-int search-button-data-analysis-table"
          hide-details
          placeholder="Search"
          append-icon="fas fa-search"
          height="30"
          dense
          solo
        ></v-text-field>
      </v-col>
    </v-row>
    <!-- 2021.12.8 203728 SPKA-305 show bottom border -->
    <v-row class="ma-0">
      <v-col cols="12" class="table-sample-content">
        <v-data-table
          :headers="headers"
          :items="items"
          :search="search"
          :items-per-page="1000"
          :class="['list-table list-table-small srm-list-table custom-border-table', items.length > 0 ? '' : 'custom-border-table-not-data']"
          :footer-props="{
            showFirstLastPage: true,
          }"
          :height="tableHeight"
          :fixed-header="true"
          dense
          hide-default-footer
        >
        <template v-slot:body="{ items }">
            <tbody>
              <tr
                v-for="(item, index) in items"
                :key="index"
                @click="onClickRow(item)"
                :class="[selectedRow === item.ITEM_ID ? 'selected_row' : '']"
              >
                <td>
                  <div v-if="item.GRP_SEQ == '00'">
                    <span>
                      <font :color="$vuetify.theme.dark ? '#F1DD2C' : '#498205'">{{item.group}}</font>
                    </span>
                  </div>
                  <div v-else>
                    <span>
                      <font :color="$vuetify.theme.dark ? '#FFA6DB' : '#BA0070'">{{item.group}}</font>
                    </span>
                  </div>
                </td>
                <td>{{item.itemName}}</td>
                <td>{{item.req}}</td>
                <td>{{item.type}}</td>
                <td>{{item.size}}</td>
                <td>{{item.valueType}}</td>
                <td>
                  <span>
                    <font :color="$vuetify.theme.dark ? '#86D9FD' : '#18236D'">{{item.exampleValue}}</font>
                  </span>
                </td>
              </tr>
            </tbody>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import $ from "jquery";
export default {

    props: {
      items: {
        default : [],
      },
      fileContent:{
        default : '',
      },
      tmpId:{
        default : '',
      },
      tmpName:{
        default : '',
      },
      clicked: {
        default: '',
      }
    },
    data: () => ({
      tableHeight:'553',
      isCreated: false,
      search: '',
      selectedRow: '',
    }),

  created() {
    this.headers = [
      { text: 'Group', value: 'group', sortable: false },
      { text: 'Item Name', value: 'itemName', sortable: false },
      { text: 'Req.', value: 'req', sortable: false, align: 'center' },
      { text: 'Type', value: 'type', sortable: false, align: 'center' },
      { text: 'Size', value: 'size', sortable: false, align: 'right' },
      { text: 'Value Type', value: 'valueType', sortable: false },
      { text: 'Example Value', value: 'exampleValue', sortable: false },
    ];
    this.isCreated = true;
  },
  updated: function() {
      let self = this; 
      let arrClassMinus = [];
      let arrClassPlus = [];
      let winWidth = $(window).width();
      let headerHeight = $('header.smartlink-header').outerHeight(true);
      let footerHeight = $('footer.v-footer').outerHeight(true);
      let paddingBottom = 15;
      let pageHeaderHeight = $('.page-header').outerHeight(true);
      let leftHeight = $('.left-grid-content').outerHeight(true);
      let rightHeight = $('.right-grid-content').outerHeight(true);
      let pageTextHeight = $('.page-text-int').outerHeight(true);
      let containerHeight;

      containerHeight = pageHeaderHeight + rightHeight + pageTextHeight + headerHeight + footerHeight + paddingBottom;
      $('.container').css('height', containerHeight);
      $(window).resize(function (event) {
        $('.container').css('height', containerHeight);
      }) 
    },
    watch: {
      items() {
        return this.items;
      },
      clicked() {
        this.itemClick(this.clicked);
      }
    },

  methods: {
    itemClick(comparedData) {
      for (let i = 0; i < this.items.length; i++) {
        if (this.items[i].GRP_NO === comparedData.group_no && this.items[i].GRP_ID === comparedData.id) {
          $('div').scrollTop(i * 35);
          // console.log(i);
        }
      }
    },
    onClickRow(item){
      this.selectedRow = item.ITEM_ID;
    }
  }
}
</script>

<style>
</style>